'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validate = undefined;

var _has2 = require('ramda/src/has');

var _has3 = _interopRequireDefault(_has2);

var _toPairs2 = require('ramda/src/toPairs');

var _toPairs3 = _interopRequireDefault(_toPairs2);

var _isNil2 = require('ramda/src/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _any2 = require('ramda/src/any');

var _any3 = _interopRequireDefault(_any2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _yup = require('yup');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var functionalValidation = {
    workplace_company: 'workplace_company'
};

var getType = function getType(item) {
    var functional = functionalValidation[(0, _path3.default)(['function'], item)];

    return (0, _path3.default)(['input', 'type'], item) || (0, _path3.default)(['select', 'type'], item) || functional;
};

var getDateError = function getDateError(value, item, onlyLastRequired) {
    if (value) {
        var invalid = value.invalid ? 'incorrectDate' : undefined;
        var requiredError = (0, _any3.default)(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                value = _ref2[1];

            return (0, _isNil3.default)(value);
        }, (0, _toPairs3.default)(value)) && item.obligatory ? 'required' : invalid || undefined;
        var day = value.day,
            month = value.month,
            year = value.year;

        var hasMonth = !(0, _isNil3.default)(month);
        var incorrectYear = year < 1900 || year > 2099 ? 'incorrectDate' : undefined;

        if ((0, _has3.default)('day', value)) {
            return day && !hasMonth && !year ? 'monthYearError' : day && hasMonth && !year ? 'yearError' : day && !hasMonth && year ? 'monthError' : !day && hasMonth && year ? 'dayError' : !day && hasMonth && !year ? 'dayYearError' : !day && !hasMonth && year ? 'dayMonthError' : incorrectYear || requiredError;
        } else {
            return !hasMonth && year ? 'monthError' : hasMonth && !year ? 'yearError' : incorrectYear || requiredError;
        }
    }

    return item.obligatory || onlyLastRequired ? 'required' : undefined;
};

var min = function min(item, data) {
    return item.min_length ? !data.value || ('' + data.value).length >= item.min_length ? '' : 'minLengthField' : '';
};
var required = function required(item, data, onlyLastRequired) {
    return !data.value && (item.obligatory || onlyLastRequired) ? 'required' : undefined;
};

var validate = exports.validate = function validate(props, item) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var onlyLastRequired = (0, _path3.default)(['obligatory_q_last'], item) === true ? (0, _path3.default)(['parent', 'parent'], props) ? !(0, _path3.default)(['parent', 'subIndex'], props) : !(0, _path3.default)(['subIndex'], props) : false;

    switch (getType(item)) {
        case functionalValidation.workplace_company:
            return required(item, data, onlyLastRequired) || data.type === 'input' && min(item, data);
        case 'phone':
            return required(item, data, onlyLastRequired) || (!data.value || ('' + (data.value || '')).length >= 12 ? '' : 'minLengthField');
        case 'email':
            return required(item, data, onlyLastRequired) || (!data.value || (0, _yup.string)().email('required').isValidSync(data.value) ? '' : 'incorrectEmail');
        case 'year':
            return required(item, data, onlyLastRequired) || (data.value && +data.value.year < 100 ? 'yearError' : undefined);
        case 'date':
        case 'month_year':
            return getDateError(data.value, item, onlyLastRequired);
        default:
            return required(item, data, onlyLastRequired) || min(item, data);
    }
};